// @flow

export default {
  errors: {
    common: {
      required: 'Required',
    },

    account: {
      firstName: "First name can't be empty",
      lastName: "Last name can't be empty",
      email: "Email can't be empty",
      password:
        'Your password must be at least 8 characters long, contains at least one number and have a mixture of uppercase and lowercase letters.',
      confirmPassword: "Confirm password can't be empty",
      isAgreed: 'Please indicate that you accept the Terms and Conditions',
    },

    saga: {
      incorrectPayload: 'Incorrect payload',
    },

    password: {
      notMatch: 'Passwords do not match',
      identical: "Old password and new password can't be identical.",
    },
  },
};
